import Decimal from "decimal.js";

/**
 * Truncate decimal number to 2 decimal places.
 */
export function decimalToFixed(num: Decimal) {
  const expression = new RegExp("(\\d+\\.\\d{2})(\\d)");
  const match = num.toString().match(expression);
  if (match) {
    let truncated = match[1];
    if (num.lessThan(0)) {
      truncated = '-' + truncated; // Negate.
    }
    return new Decimal(truncated);
  }
  return num;
};

/**
 * Round up to 2 decimal places.
 * Used for when JS floating point math leaves trailing zeros.
 * Example: 0.2 + 0.4
 */
export function roundDecimal(num: Decimal) {
  let numForCeil = num.times(100);
  // Truncate any floating point trailing zeros. Covers JS floating point multiplication with decimals, such as (64.9 * 100).
  numForCeil = decimalToFixed(numForCeil);
  if (!(numForCeil.modulo(1).equals(0))) {
    // numForCeil is still a decimal, round up. Example: a rate of 59.5959 needs to be 59.60.
    return Decimal.ceil(numForCeil).dividedBy(100);
  } else {
    // Number is a whole or decimal with no trailing zeros.
    return num;
  }
}

export function NormalizeCurrencyInput(value: string, negative: boolean = false) {
  let numbersOnly: string = value.replace(/[^0-9]/g, "");
  if (numbersOnly.length > 0) {
    if (numbersOnly.length < 3) {
      numbersOnly = numbersOnly.padStart(3, '0');
    }
  }
  else {
    return "";
  }
  let start: string = numbersOnly.slice(0, -2);
  let end: string = numbersOnly.slice(-2);

  let decimalNumber: string = start + "." + end;
  decimalNumber = decimalNumber.replace(/(^[0]+)([0-9][.][0-9]{2}$)/, "$2");

  return (negative ? '-' : '') + decimalNumber;
}

export function isStringEmpty(str: string | undefined | null) {
  return str === "" || str == undefined || str === null;
}

export function ObjToQueryString(params: any = {}): string {
  return Object.keys(params).filter((key) => params[key] !== null && ((typeof params[key] === 'string' && params[key].length > 0) || typeof params[key] === 'number' || typeof params[key] === 'boolean')).map((key) => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
  }).join('&');
}